import { withKey, withoutKey, type GlobalStateContext } from 'piral-core'
import type { UserActionRegistration, UserTitleRendererRegistration } from './UserMenuApi'

export function registerUserTitleRenderer(ctx: GlobalStateContext, name: string, value: UserTitleRendererRegistration) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      userTitleRendererItems: withKey(state.registry.userTitleRendererItems, name, value)
    }
  }))
}

export function unregisterUserTitleRenderer(ctx: GlobalStateContext, name: string) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      userTitleRendererItems: withoutKey(state.registry.userTitleRendererItems, name)
    }
  }))
}

export function registerUserAction(ctx: GlobalStateContext, name: string, value: UserActionRegistration) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      userActionItems: withKey(state.registry.userActionItems, name, value)
    }
  }))
}

export function unregisterUserAction(ctx: GlobalStateContext, name: string) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      userActionItems: withoutKey(state.registry.userActionItems, name)
    }
  }))
}
